import {NgModule} from "@angular/core";
import {SkjermingDialogKomponentAvhengigheter} from "web-ng2/moduler/skjerming/modale/skjerming-dialog/skjerming-dialog";

@NgModule({
    providers: [
        SkjermingDialogKomponentAvhengigheter
    ]
})
export class SkjermingModul{

}
